import React from "react";
import "../Solutions.css";

import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import networkImg from "../../../assets/network-security.jfif";
import cloudImg from "../../../assets/cloud-security.jfif";
import identityImg from "../../../assets/identity-security.jfif";
import endpointImg from "../../../assets/endpoint-security.jfif";
import vaptImg from "../../../assets/penetration-testing.jfif";
import socImg from "../../../assets/soc-monitorin.jfif";
import grcImg from "../../../assets/grc-security.jfif";
import incidentImg from "../../../assets/incident-response.jfif";

import { motion } from "framer-motion";

import {

    FaNetworkWired,
    FaCloud,
    FaUserShield,
    FaLaptopMedical,
    FaSearch,
    FaServer,
    FaClipboardCheck,
    FaBug,
    FaArrowRight

} from "react-icons/fa";



const solutions = [


    {
        icon: <FaNetworkWired />,
        title: "Network Security",


        image: networkImg,

        description:
            "BlueLotus Infrasafety Projects Private Limited Network Security solutions are designed to safeguard your organization's entire network infrastructure from unauthorized access, cyber attacks, ransomware, and data breaches. We deploy enterprise-grade firewalls, intrusion prevention systems, secure VPN connectivity, network segmentation, and continuous traffic monitoring to establish a strong first line of defense. Our security experts continuously analyze network activity, identify suspicious behavior, and implement proactive security controls to minimize risks. Whether your infrastructure is on-premises, hybrid, or cloud-connected, we ensure reliable, scalable, and resilient network protection that keeps your business running securely.",

        features: [
            "Firewall Management",
            "Intrusion Detection & Prevention",
            "Network Monitoring",
            "Secure Network Architecture"
        ]

    },



    {
        icon: <FaCloud />,
        title: "Cloud Security",
        image: cloudImg,

        description:
            "Modern organizations increasingly rely on cloud platforms to power business operations. BlueLotus Infrasafety Projects Private Limited Cloud Security services help organizations securely adopt AWS, Microsoft Azure, Google Cloud, and hybrid cloud infrastructures while maintaining complete visibility and control over sensitive workloads and business data. Our cloud security specialists implement secure cloud architecture, identity management, workload protection, encryption, continuous configuration monitoring, and compliance best practices to reduce risks. We help organizations confidently embrace digital transformation without compromising security.",

        features: [
            "Cloud Risk Assessment",
            "Data Protection",
            "Cloud Configuration Security",
            "Workload Protection"
        ]

    },



    {
        icon: <FaUserShield />,
        title: "Identity & Access Management",

        image: identityImg,

        description:
            "Identity has become the new security perimeter. BlueLotus Infrasafety Projects Private Limited Identity & Access Management (IAM) solutions ensure that only authorized users have access to critical business applications, systems, and sensitive information through intelligent authentication and access control policies. Our Zero Trust approach combines Multi-Factor Authentication (MFA), Single Sign-On (SSO), Privileged Access Management (PAM), role-based permissions, and identity governance to reduce insider threats and unauthorized access while improving user productivity.",

        features: [
            "Multi-Factor Authentication",
            "User Access Management",
            "Privileged Access Security",
            "Identity Governance"
        ]

    },



    {
        icon: <FaLaptopMedical />,
        title: "Endpoint Protection",
        image: endpointImg,

        description:
            "Every endpoint connected to your business network represents a potential entry point for cyber attackers. BlueLotus Infrasafety Projects Private Limited Endpoint Protection secures desktops, laptops, mobile devices, servers, and remote workstations against malware, ransomware, phishing attacks, and advanced persistent threats. Our intelligent endpoint security platform leverages AI-powered threat detection, Endpoint Detection & Response (EDR), behavioral analytics, device control, and continuous monitoring to detect, isolate, and remediate threats before they can disrupt business operations.",

        features: [
            "Endpoint Detection Response",
            "Malware Protection",
            "Device Monitoring",
            "Threat Prevention"
        ]

    },




    {
        icon: <FaSearch />,
        title: "Vulnerability Assessment & Penetration Testing",

        image: vaptImg,

        description:
            "Cybersecurity begins with understanding your organization's security posture. BlueLotus Infrasafety Projects Private Limited Vulnerability Assessment & Penetration Testing (VAPT) services identify weaknesses across applications, networks, cloud infrastructure, APIs, and internal systems before attackers can exploit them. Our certified security professionals perform comprehensive vulnerability scanning, ethical hacking, security validation, and detailed risk assessments. We provide prioritized remediation recommendations that help organizations strengthen defenses and reduce overall cyber risk.",

        features: [
            "Security Auditing",
            "Penetration Testing",
            "Risk Identification",
            "Remediation Guidance"
        ]

    },




    {
        icon: <FaServer />,
        title: "Security Operations Center",
        image: socImg,

        description:
            "BlueLotus Infrasafety Projects Private Limited Security Operations Center (SOC) delivers continuous 24×7 monitoring, threat intelligence, incident detection, and rapid response capabilities to protect organizations against modern cyber threats. Our dedicated security analysts continuously monitor security events across your infrastructure using advanced SIEM technologies. By combining automated threat detection with human expertise, our SOC enables organizations to identify suspicious activities early, investigate incidents efficiently, and respond before cyber attacks impact business operations.",
        features: [
            "24×7 Monitoring",
            "Threat Intelligence",
            "Security Analytics",
            "Incident Detection"
        ]

    },




    {
        icon: <FaClipboardCheck />,
        title: "Governance, Risk & Compliance",
        image: grcImg,

        description:
            "Strong cybersecurity requires effective governance and regulatory compliance. BlueLotus Infrasafety Projects Private Limited Governance, Risk & Compliance (GRC) services help organizations establish security frameworks, manage enterprise risks, and meet industry-specific compliance requirements including ISO 27001, GDPR, HIPAA, PCI DSS, and other regulatory standards. We assess organizational risks, develop security policies, conduct compliance audits, and implement governance programs that align cybersecurity initiatives with overall business objectives while improving operational resilience.",

        features: [
            "Risk Assessment",
            "Security Policies",
            "Compliance Management",
            "Audit Support"
        ]

    },




    {
        icon: <FaBug />,
        title: "Incident Response",
        image: incidentImg,

        description:
            "Cyber incidents require immediate action to minimize operational disruption and financial losses. BlueLotus Infrasafety Projects Private Limited Incident Response services provide rapid investigation, threat containment, digital forensics, recovery planning, and post-incident analysis to help organizations recover quickly and securely. Our experienced incident response specialists identify attack vectors, isolate compromised systems, preserve forensic evidence, and implement long-term security improvements to reduce the likelihood of future cyber attacks while strengthening organizational resilience.",

        features: [
            "Threat Investigation",
            "Incident Containment",
            "Digital Forensics",
            "Recovery Planning"
        ]

    }


];





const Solutions = () => {


    return (

        <>


            <Header />


            <title>
                Cybersecurity Solutions | BlueLotus Infrasafety Projects Private Limited
            </title>



            {/* HERO */}


            <section className="solutions-hero">


                <div className="container">


                    <motion.div

                        className="solutions-hero-content"

                        initial={{ opacity: 0, y: 50 }}

                        animate={{ opacity: 1, y: 0 }}

                        transition={{ duration: .8 }}

                    >


                        <span>

                            Advanced Cybersecurity Solutions

                        </span>


                        <h1>

                            Protect Your Business

                            <h1 style={{ display: "Block", color: "#60a5fa" }}>Against Modern Cyber Threats</h1>

                        </h1>


                        <p>

                            BlueLotus Infrasafety Projects Private Limited provides comprehensive cybersecurity
                            solutions designed to protect your infrastructure,
                            applications, users, and critical business data.

                        </p>


                    </motion.div>


                </div>


            </section>







            {/* INTRO */}


            <section className="solutions-intro">


                <div className="container">


                    <h2>

                        Complete Security Solutions For Modern Enterprises

                    </h2>


                    <p>

                        Cyber threats are constantly evolving. Organizations
                        need proactive security strategies that combine
                        technology, expertise, and continuous monitoring.

                        BlueLotus Infrasafety Projects Private Limited delivers end-to-end cybersecurity
                        solutions that help businesses prevent attacks,
                        reduce risks, and maintain operational resilience.

                    </p>


                </div>


            </section>








            {/* SOLUTIONS */}



            <section className="solution-details">


                <div className="container">


                    {
                        solutions.map((item, index) => (


                            <div
                                className={`solution-detail-row ${index % 2 !== 0 ? "reverse" : ""
                                    }`}
                                key={index}
                            >


                                {/* CONTENT */}

                                <div className="solution-detail-content">


                                    <span className="solution-number">

                                        0{index + 1}

                                    </span>


                                    <h2>

                                        {item.title}

                                    </h2>


                                    <p>

                                        {item.description}

                                    </p>


                                    <h4>

                                        Key Capabilities

                                    </h4>


                                    <ul>

                                        {
                                            item.features.map((feature, i) => (

                                                <li key={i}>

                                                    {feature}

                                                </li>

                                            ))
                                        }

                                    </ul>


                                    <a href="/contact">

                                        Talk To Security Experts

                                    </a>


                                </div>





                                {/* IMAGE */}


                                <div className="solution-detail-image">


                                    <img

                                        src={item.image}

                                        alt={item.title}

                                    />


                                </div>



                            </div>


                        ))

                    }



                </div>


            </section>









            {/* SECURITY APPROACH */}


            <section className="solution-process">


                <div className="container">


                    <h2>

                        Our Security Approach

                    </h2>



                    <div className="process-grid">


                        <div>

                            01

                            <h3>Identify</h3>

                            <p>
                                Discover vulnerabilities and security risks.
                            </p>

                        </div>


                        <div>

                            02

                            <h3>Protect</h3>

                            <p>
                                Implement advanced security controls.
                            </p>

                        </div>


                        <div>

                            03

                            <h3>Monitor</h3>

                            <p>
                                Continuously detect cyber threats.
                            </p>

                        </div>


                        <div>

                            04

                            <h3>Respond</h3>

                            <p>
                                Rapidly contain and recover from incidents.
                            </p>

                        </div>


                    </div>


                </div>


            </section>








            {/* CTA */}


            <section className="solution-cta">


                <div className="container">


                    <h2>

                        Secure Your Organization With BlueLotus Infrasafety Projects Private Limited

                    </h2>


                    <p>

                        Connect with our cybersecurity specialists
                        to build a stronger security foundation.

                    </p>


                    <a href="/consultation">

                        Get Security Consultation

                        <FaArrowRight />

                    </a>


                </div>


            </section>




            <Footer />


        </>


    )

}


export default Solutions;